import React from "react";
import ImageComponentView from "./ImageComponentView";

export const ImageComponentContainer = (props) => {
  return <ImageComponentView id={props.id} name={props.name} url={props.url} />;
};
